import Table from "../components/consent-information-transfer-results/Table"
import { useAuthenticationHook } from "../app/useAuthenticationHook";
import { PERMISSIONS } from "../configs/constants";
import { SpaceBetween } from "@cloudscape-design/components-themed";

/* 
承諾情報移管結果履歴画面
*/
const ConsentInformationTransferResults = () => {
    //権限制御
    useAuthenticationHook(PERMISSIONS.MASTER_EDIT);
    return (
        <SpaceBetween size="l">
            <Table />
        </SpaceBetween>
    );
};

export default ConsentInformationTransferResults;